/**
 * src/lib/apply-theme.js — injects the generated token stylesheet.
 *
 * design-tokens/themes.js is plain data (safe to import from Node — the
 * contrast test does exactly that); this is the one module that turns it
 * into a live `<style>` tag, so importing themes.js never has a DOM
 * dependency.
 */
import { generateCSS } from '../design-tokens/themes.js';

const STYLE_TAG_ID = 'design-tokens';

/**
 * Inserts (once) or reuses a `<style>` element holding every theme's CSS
 * custom properties, generated from design-tokens/themes.js. Call once,
 * before the app renders — see main.jsx.
 *
 * @returns {void}
 */
export function injectThemeTokens() {
  if (document.getElementById(STYLE_TAG_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_TAG_ID;
  style.textContent = generateCSS();
  // Appended at the END of <head>, after the small inline critical-CSS
  // fallback in index.html (see that file's comment) — later
  // same-specificity rules win, so once this runs it correctly supersedes
  // the fallback rather than losing to it.
  document.head.appendChild(style);
}
